import { DataSeries } from "../Charts";
import { GameSummary } from "./types";

const leadingZero = Intl.NumberFormat(undefined, { minimumIntegerDigits: 2 }).format;
export function formatSecondsAsDuration(duration: number) {
  const seconds = leadingZero(duration % 60);
  const minutes = Math.floor(duration / 60);
  return `${minutes}:${seconds}`;
}

type Steps = GameSummary["groupedSteps"] | GameSummary["steps"];
export function groupedStepsByPeriod(steps: Steps, interval = 60) {
  const periods: Steps[] = Array.from(Array(Math.ceil(steps.at(-1).timestamp / interval)), () => []);
  for (const step of steps) {
    const period = Math.floor(step.timestamp / interval);
    periods[period]?.push(step as Steps[0]);
  }
  return periods;
}

export function resourcesToDataSeries(resources: GameSummary["resources"]): DataSeries[] {
  return [
    {
      label: "Food",
      data: resources.food,
      color: "#FF3838",
    },
    {
      label: "Wood",
      data: resources.wood,
      color: "#9B5D00",
    },
    {
      label: "Gold",
      data: resources.gold,
      color: "#FFE300",
    },
    {
      label: "Stone",
      data: resources.stone,
      color: "#AEAEAE",
    },
  ];
}

export function sumDeltas(numbers: number[]) {
  return numbers.reduce((cum, v, i, a) => {
    cum[i] = v + (cum[i - 1] ?? 0);
    return cum;
  }, []);
}

export function sumPerInterval(item: GameSummary["items"][0], intervals: number[]) {
  const delta: number[] = Array(intervals.length).fill(0);
  const addDelta = (timestamp: number, i: number) => (delta[intervals.findIndex((i) => i > timestamp)] += i);
  item.build.forEach((b) => addDelta(b, 1));
  item.lost.forEach((l) => addDelta(l, -1));
  return sumDeltas(delta);
}

export function populationValuesPerInterval(stats: GameSummary["items"], intervals: number[]) {
  const armyValueDeltas: number[] = Array(intervals.length).fill(0);
  const popcapDeltas: number[] = Array(intervals.length).fill(0);
  const workerCountDeltas: number[] = Array(intervals.length).fill(0);
  for (const stat of stats) {
    const vari = stat.item.variations?.[0];
    if (!vari || stat.item.type != "unit") continue;

    const { total, popcap } = stat.item.variations[0].costs;
    for (const timestamp of stat.build) {
      const i = intervals.findIndex((interval) => interval > timestamp);
      if (i >= 0) {
        if (stat.item.classes.includes("worker")) workerCountDeltas[i] += 1;
        else armyValueDeltas[i] += total;
        popcapDeltas[i] += isNaN(popcap) ? 0 : popcap;
      }
    }
    for (const timestamp of stat.lost) {
      const i = intervals.findIndex((interval) => interval > timestamp);
      if (i >= 0) {
        if (stat.item.classes.includes("worker")) workerCountDeltas[i] -= 1;
        else armyValueDeltas[i] -= total;
        popcapDeltas[i] -= isNaN(popcap) ? 0 : popcap;
      }
    }
  }
  return {
    army: sumDeltas(armyValueDeltas),
    popcap: sumDeltas(popcapDeltas),
    workers: sumDeltas(workerCountDeltas),
  };
}
